var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBarChart = function SvgBarChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgBarChart",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.svgBarChart{fill:#FFFFFF;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    className: "svgBarChart svgBase svgHover svgSelect",
    d: "M5.5,8.5c-0.3,0-0.6,0.3-0.6,0.6v6.1c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6V9.1 C6.1,8.7,5.8,8.5,5.5,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    className: "svgBarChart svgBase svgHover svgSelect",
    d: "M0.9,4.6c-0.3,0-0.6,0.3-0.6,0.6v10c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6v-10 C1.4,4.8,1.2,4.6,0.9,4.6C0.9,4.6,0.9,4.6,0.9,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    className: "svgBarChart svgBase svgHover svgSelect",
    d: "M10.5,0.3c-0.3,0-0.6,0.3-0.6,0.6v14.3c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6V0.9 C11.1,0.5,10.8,0.3,10.5,0.3C10.5,0.3,10.5,0.3,10.5,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    className: "svgBarChart svgBase svgHover svgSelect",
    d: "M15.2,4.2c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0v10.4c0,0.3,0.3,0.6,0.6,0.6 c0.3,0,0.6-0.3,0.6-0.6V4.8C15.7,4.5,15.5,4.2,15.2,4.2C15.2,4.2,15.2,4.2,15.2,4.2L15.2,4.2z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar_chart.08cde632.svg";
export { ForwardRef as ReactComponent };